import React, { Component } from 'react';
import Imagecard from '../Imagecard/Imagecard.js'
import {Videoplayer} from '../../components/Videoplayer/Videoplayer.js'

import './Gallery.scss';

export class Gallery extends Component {

  constructor(props) {
    super(props);
    this.state = { data: {} };
  }

  componentDidMount() {}

  render() {

    let columns = (this.props.cols) ? this.props.cols : 'four';

    return (
      <section className={`gallery gallery--${columns}`}>
        {this.props.innercontent.map((child, index) => {
          let type = (child.type) ? child.type : 'image';
          let ratio = (child.ratio) ? child.ratio : 'regular';
          return (
            <div className="gallery__item" key={index}>
              {type === 'image' &&
                <Imagecard image={child.src} alt={child.alt} ratio={ratio} />
              || type === 'video' &&
                //<Videoplayer url={child.videourl} loop={false} />
                <a
                  srl_video_thumbnail={child.src}
                  srl_video_loop="false"
                  srl_video_scale="100"
                  srl_video_caption=""
                  href={child.videourl}
                  className="slider__item__link"
                >
                  <img src={child.src} alt="" />
                </a>
              || type === 'videouploaded' &&
                <Videoplayer url={child.videourl} ratio={ratio} loop={true} controls="false" autoplay={true} />
              }

            </div>
          )
        })}
      </section>
    )
  }

}
